<script lang="ts">
  import type { StorageReference } from "firebase/storage"
  import { createEventDispatcher } from "svelte"

  import { ContentType } from "../types"
  import Header from "./header.svelte"
  import Sidebar from "./sidebar.svelte"
  import ListView from "./list.svelte"
  import UploadProgress from "./upload-progress/index.svelte"

  export let selectedContetType: ContentType = ContentType.PDF
  export let editable: boolean = false
  let invalidateView: () => Promise<StorageReference[]>
  let deleteSelectedFiles: () => Promise<void>
  let hasSelectItem: boolean

  const dispatch = createEventDispatcher()

  function onClickReload() {
    invalidateView()
  }

  function onDeleteFiles() {
    deleteSelectedFiles?.()
  }

  function onScreenShare() {
    // TODO
  }

  function onOpenFile(e: CustomEvent) {
    dispatch("startpresentation", e.detail)
  }
</script>

<div class="materials">
  <div class="header">
    <Header
      contentType={selectedContetType}
      {editable}
      disabledDeleteButton={!hasSelectItem}
      on:delete={onDeleteFiles}
      on:screenshare={onScreenShare}
    />
  </div>
  <div class="sidebar">
    <Sidebar bind:selectedContetType on:reload={onClickReload} />
  </div>
  <div class="listview">
    <ListView
      contentType={selectedContetType}
      {editable}
      bind:invalidate={invalidateView}
      bind:deleteSelectedFiles
      bind:hasSelectItem
      on:open={onOpenFile}
    />
  </div>
  <div class="uploadprogress">
    <UploadProgress />
  </div>
</div>

<style>
  .materials {
    position: relative;
    display: grid;
    gap: 0.5em;
    grid-template-areas:
      "sidebar header"
      "sidebar content";
    grid-template-columns: repeat(12, [col-start] 1fr);
    grid-template-rows: auto 1fr;
    background: var(--presentation-background);
    border-radius: 5px;
    width: 100%;
    height: 100%;
  }
  .header {
    grid-area: header;
    grid-column: col-start / span 12;
  }
  .sidebar {
    grid-area: sidebar;
    grid-column: col-start / span 3;
    overflow: hidden;
  }
  .listview {
    grid-area: content;
    grid-column: col-start 4 / span 9;
    overflow: hidden;
    margin-right: 0.5em;
    margin-bottom: 1em;
    position: relative;
  }
  .uploadprogress {
    position: absolute;
    bottom: 1em;
    right: 1em;
  }
</style>
